import {CommonDataResource} from "./common-data-resource";

export namespace CommonData {
  export interface UserData {
    id: number;
    userName: string;
    personName: string;
    creationTime: string;
  }

  export class Mapper {
    public static toPublicUser(r: CommonDataResource.UserDataResource): UserData {
      return {
        id: r.id,
        userName: r.user_name,
        personName: r.person_name,
        creationTime: r.creation_time
      }
    }
  }
}
